import React, { FC, useEffect, useState } from 'react';
import { VideoFieldModel } from '../../../../models/form/fields/video';
import YouTube from 'react-youtube';

export interface Props {
  src: string | undefined;
  videoPlayer: VideoFieldModel['videoPlayer'];
}

const VideoField: FC<Props> = ({ src, videoPlayer }: Props) => {
  const [cleanUrl, setCleanUrl] = useState<string>('');

  useEffect(() => {
    if (src && src?.length > 0) {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = src.match(regExp);
      setCleanUrl(match && match[7].length == 11 ? match[7] : '');
    }
  }, []);

  return (
    <div className="video-field" data-testid="video-test">
      {videoPlayer === 'youtube' && src && (
        <div className="youtube-container" data-testid="youtube-test">
          <YouTube videoId={cleanUrl} iframeClassName="video-player-frame" />
        </div>
      )}
      {videoPlayer != 'youtube' && src && (
        <div className="frame-container">
          <iframe src={src} frameBorder="0" data-testid="frame-test" />
        </div>
      )}
    </div>
  );
};

export default VideoField;
